webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ORIGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DESTINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FLIGHT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */]);

var ORIGIN = 1;
var DESTINATION = 2;
var FLIGHT = 3;

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* default */].Store({
  state: {
    origins: [{ id: 'los_angeles', name: 'Los Angeles', img: './static/los_angeles.jpg' }, { id: 'chicago', name: 'Chicago', img: './static/chicago.jpg' }, { id: 'philadelphia', name: 'Philadelphia', img: './static/philadelphia.jpg' }, { id: 'new_york_city', name: 'New York City', img: './static/new_york_city.jpg' }, { id: 'houston', name: 'Houston', img: './static/houston.jpg' }, { id: 'dallas', name: 'Dallas', img: './static/dallas.jpg' }],
    destinations: {
      los_angeles: [{ id: 'beach', name: 'Beach', img: './static/beach.jpg' }, { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' }, { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' }, { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' }, { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' }, { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }],
      dallas: [{ id: 'beach', name: 'Beach', img: './static/beach.jpg' }, { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' }, { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' }, { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' }, { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' }, { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }],
      chicago: [{ id: 'beach', name: 'Beach', img: './static/beach.jpg' }, { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' }, { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' }, { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' }, { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' }, { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }],
      philadelphia: [{ id: 'beach', name: 'Beach', img: './static/beach.jpg' }, { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' }, { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' }, { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' }, { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' }, { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }],
      new_york_city: [{ id: 'beach', name: 'Beach', img: './static/beach.jpg' }, { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' }, { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' }, { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' }, { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' }, { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }],
      houston: [{ id: 'beach', name: 'Beach', img: './static/beach.jpg' }, { id: 'party_hub', name: 'Party Hub', img: './static/party_hub.jpg' }, { id: 'back_to_nature', name: 'Back to Nature', img: './static/back_to_nature.jpg' }, { id: 'family_vacation', name: 'Family Vacation', img: './static/family_vacation.jpg' }, { id: 'ski_resort', name: 'Snowy Adventure', img: './static/ski_resort.jpg' }, { id: 'foodie_paradise', name: 'Foodie Paradise', img: './static/foodie.jpg' }]
    },
    flights: {
      los_angeles: {
        beach: [{
          id: 2,
          origin: {
            city: 'Los Angeles',
            airport: 'LAX'
          },
          destination: {
            city: 'Miami',
            airport: 'MIA'
          },
          trip: {
            leave: 'Monday, Sep 4',
            return: 'Friday, Sep 8',
            duration: 5
          },
          airline: 'American Airlines',
          price: 133,
          details: false,
          attractions: false
        }, {
          id: 1,
          origin: {
            city: 'Los Angeles',
            airport: 'LAX'
          },
          destination: {
            city: 'Fort Lauderdale',
            airport: 'FLL'
          },
          trip: {
            leave: 'Sunday, Sep 10',
            return: 'Friday, Sep 15',
            duration: 6
          },
          airline: 'American Airlines',
          price: 233,
          details: false,
          attractions: false
        }, {
          id: 4,
          origin: {
            city: 'Los Angeles',
            airport: 'LAX'
          },
          destination: {
            city: 'Honolulu',
            airport: 'HNL'
          },
          trip: {
            leave: 'Monday, Sep 4',
            return: 'Saturday, Sep 9',
            duration: 6
          },
          airline: 'Alaska Airlines',
          price: 444,
          details: false,
          attractions: false
        }, {
          id: 3,
          origin: {
            city: 'Los Angeles',
            airport: 'LAX'
          },
          destination: {
            city: 'Honolulu',
            airport: 'HNL'
          },
          trip: {
            leave: 'Thursday, Sep 7',
            return: 'Saturday, Sep 16',
            duration: 10
          },
          airline: 'Alaska Airlines',
          price: 456,
          details: false,
          attractions: false
        }, {
          id: 5,
          origin: {
            city: 'Los Angeles',
            airport: 'LAX'
          },
          destination: {
            city: 'Myrtle Beach',
            airport: 'MYR'
          },
          trip: {
            leave: 'Friday, Sep 1',
            return: 'Tuesday, Sep 5',
            duration: 5
          },
          airline: 'United Airlines',
          price: 632,
          details: false,
          attractions: false
        }]
      },
      dallas: {
        family_vacation: [{
          id: 7,
          origin: {
            city: 'Dallas/Fort Worth',
            airport: 'DFW'
          },
          destination: {
            city: 'San Diego',
            airport: 'SAN'
          },
          trip: {
            leave: 'Friday, Sep 15',
            return: 'Sunday, Sep 17',
            duration: 3
          },
          airline: 'Spirit Airlines',
          price: 221,
          details: false,
          attractions: false
        }, {
          id: 8,
          origin: {
            city: 'Dallas/Fort Worth',
            airport: 'DFW'
          },
          destination: {
            city: 'San Diego',
            airport: 'SAN'
          },
          trip: {
            leave: 'Friday, Sep 15',
            return: 'Wednesday, Sep 20',
            duration: 6
          },
          airline: 'United Airlines',
          price: 298,
          details: false,
          attractions: false
        }, {
          id: 6,
          origin: {
            city: 'Dallas/Fort Worth',
            airport: 'DFW'
          },
          destination: {
            city: 'Orlando',
            airport: 'MCO'
          },
          trip: {
            leave: 'Friday, Sep 1',
            return: 'Monday, Sep 4',
            duration: 4
          },
          airline: 'American Airlines',
          price: 322,
          details: false,
          attractions: false
        }, {
          id: 7,
          origin: {
            city: 'Dallas/Fort Worth',
            airport: 'DFW'
          },
          destination: {
            city: 'San Diego',
            airport: 'SAN'
          },
          trip: {
            leave: 'Friday, Sep 15',
            return: 'Sunday, Sep 17',
            duration: 3
          },
          airline: 'American Airlines',
          price: 387,
          details: false,
          attractions: false
        }]
      }
    },
    ata: {
      FLL: ['a345', 'a333'],
      MIA: ['a333', 'a345'],
      MCO: ['w345'],
      SAN: ['s321'],
      MYR: ['m321'],
      HNL: ['h321']
    },
    attractions: {
      a345: {
        name: 'Miami Beach',
        img: './static/miami_beach.jpg',
        description: 'Great beach with white sand and blue water.'
      },
      a333: {
        name: 'Fort Lauderdale Beach',
        img: './static/fort_lauderdale_beach.jpg',
        description: 'Great beach with white sand and blue water.'
      },
      w345: {
        name: 'Walt Disney World Resort',
        img: './static/walt_disney_world_resort.jpg',
        description: 'You can have a lot of fun here with or without kids.'
      },
      s321: {
        name: 'Legoland California Resort',
        img: './static/legoland_california_resort.jpg',
        description: 'Lot\'s of LEGOs here to see and play with.'
      },
      m321: {
        name: 'Myrtle Beach',
        img: './static/myrtle_beach.jpg',
        description: 'Great beach with white sand and blue water.'
      },
      h321: {
        name: 'Waikiki Beach',
        img: './static/waikiki_beach.jpg',
        description: 'Great beach with white sand and blue water.'
      }
    },
    scene: ORIGIN,
    origin: undefined,
    destination: undefined,
    flight: undefined
  },
  getters: {
    sceneIsOrigin: function sceneIsOrigin(state) {
      return state.scene === ORIGIN;
    },
    sceneIsDestination: function sceneIsDestination(state) {
      return state.scene === DESTINATION;
    },
    sceneIsFlight: function sceneIsFlight(state) {
      return state.scene === FLIGHT;
    },
    originIsUnknown: function originIsUnknown(state) {
      return !state.origin;
    },
    origin: function origin(state) {
      return state.origin;
    }
  },
  mutations: {
    setOrigin: function setOrigin(state, origin) {
      state.origin = origin;
    },
    setDestination: function setDestination(state, destination) {
      state.destination = destination;
    },
    setScene: function setScene(state, scene) {
      state.scene = scene;
    }
  },
  actions: {
    setOrigin: function setOrigin(_ref, origin) {
      var commit = _ref.commit;

      commit('setOrigin', origin);
      commit('setDestination', undefined);
      commit('setScene', DESTINATION);
    },
    setDestination: function setDestination(_ref2, destination) {
      var commit = _ref2.commit;

      commit('setDestination', destination);
      commit('setScene', FLIGHT);
    },
    setSceneOrigin: function setSceneOrigin(_ref3) {
      var commit = _ref3.commit;

      commit('setScene', ORIGIN);
    },
    setSceneDestination: function setSceneDestination(_ref4) {
      var commit = _ref4.commit;

      commit('setScene', DESTINATION);
    },
    setSceneFlight: function setSceneFlight(_ref5) {
      var commit = _ref5.commit;

      commit('setScene', FLIGHT);
    }
  }
}));

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(57)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(69),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4b7f1adc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Wizard__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Book__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Book___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Book__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  routes: [{
    path: '/',
    name: 'Wizard',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Wizard___default.a
  }, {
    path: '/book',
    name: 'Book',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Book___default.a
  }]
}));

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var directive = {};

directive.onEvent = function (event) {
  if (event.target !== this.el && !this.el.contains(event.target)) {
    directive.cb && directive.cb(event);
  }
};

directive.bind = function (el) {
  console.log('bound');
  // var t = 0
  // t++
  // if (t > 1) {
  directive.onEventBound = directive.onEvent.bind({ el: el });
  document.addEventListener('click', directive.onEventBound);
  // t++
  // }
};

directive.update = function (el, binding) {
  if (typeof binding.value !== 'function') {
    throw new Error('Argument must be a function');
  }
  directive.cb = binding.value;
};

directive.unbind = function () {
  document.removeEventListener('click', directive.onEventBound);
};

/* harmony default export */ __webpack_exports__["a"] = (directive);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(58)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(70),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__vout__ = __webpack_require__(16);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// import vClickOutside from 'v-click-outside'


// Vue.use(vClickOutside)
// Vue.use(vcout)
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('click-outside', __WEBPACK_IMPORTED_MODULE_4__vout__["a" /* default */]);

// Vue.directive('dismiss', {
//   // When the bound element is inserted into the DOM...
//   inserted: function (el) {
//     // Focus the element
//     el.focus()
//   }
// })

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Wizard__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Wizard__);
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { Wizard: __WEBPACK_IMPORTED_MODULE_0__components_Wizard___default.a }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wizard'
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'destinations',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    destinations: function destinations(state) {
      return state.destinations[state.origin.id];
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setDestination']))
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flight',
  props: ['flight'],
  // data: function () {
  //   return {
  //     attractions: false,
  //     details: false
  //   }
  // },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    flights: function flights(state) {
      return state.flights;
    },
    attractionsList: function attractionsList(state) {
      console.log(state.ata[this.flight.destination.airport]);
      return state.ata[this.flight.destination.airport].map(function (attraction) {
        return state.attractions[attraction];
      });
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['chooseFlight']))
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Flight__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Flight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Flight__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'flights',
  data: function data() {
    return {
      attractions: false,
      menu: false,
      selection: 'Cheapest First',
      sorting: {
        menu: false,
        selection: {
          display: 'Cheapest First',
          key: 'price',
          direction: 'asc'
        },
        options: [{
          display: 'Cheapest First',
          key: 'price',
          direction: 'asc'
        }, {
          display: 'Expensive First',
          key: 'price',
          direction: 'desc'
        }, {
          display: 'Shortest First',
          key: 'duration',
          direction: 'asc'
        }, {
          display: 'Longest First',
          key: 'duration',
          direction: 'desc'
        }]
      }
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    flights: function flights(state) {
      return state.flights[state.origin.id] && state.flights[state.origin.id][state.destination.id] || [];
    },
    filtering: function filtering(state) {
      return {
        menu: false,
        selection: {
          display: 'No Filter',
          key: 'none',
          filtering: {
            menu: false,
            selection: {
              display: 'No Filter',
              key: 'none'
            }
          }
        },
        options: [{
          display: 'Duration',
          key: 'duration',
          options: state.flights.map(function (flight) {
            return flight.trip.duration;
          })
        }]
      };
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    onClickOutside: function onClickOutside(event) {
      this.sorting.menu = false;
    },
    sort: function sort(option) {
      this.sorting.menu = false;
      this.sorting.selection = option;
      return this.flights.sort(function (a, b) {
        var x = null;
        var y = null;

        switch (option.key) {
          case 'price':
            x = a.price;
            y = b.price;
            break;
          case 'duration':
            x = a.trip.duration;
            y = b.trip.duration;
            break;
        }
        if (option.direction === 'asc') {
          return x < y ? -1 : x > y ? 1 : 0;
        } else {
          return x > y ? -1 : x < y ? 1 : 0;
        }
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['chooseFlight'])),
  components: {
    Flight: __WEBPACK_IMPORTED_MODULE_2__Flight___default.a
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'origins',
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    origins: function origins(state) {
      return state.origins;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setOrigin']))
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Origins__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Origins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Origins__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Destinations__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Destinations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Destinations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Flights__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Flights___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Flights__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wizard',
  data: function data() {
    return {
      transition: 'slide-right'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    origin: function origin(state) {
      return state.origin;
    },
    destination: function destination(state) {
      return state.destination;
    },
    flight: function flight(state) {
      return state.flight;
    },
    ifo: function ifo(state) {
      return state.scene === __WEBPACK_IMPORTED_MODULE_2__store__["b" /* ORIGIN */];
    },
    ifd: function ifd(state) {
      return state.scene === __WEBPACK_IMPORTED_MODULE_2__store__["c" /* DESTINATION */];
    },
    iff: function iff(state) {
      return state.scene === __WEBPACK_IMPORTED_MODULE_2__store__["d" /* FLIGHT */];
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sceneDestination: function sceneDestination() {
      if (!this.origin) return;
      this.setSceneDestination();
    },
    sceneFlight: function sceneFlight() {
      if (!this.origin || !this.destination) return;
      this.setSceneFlight();
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['setSceneOrigin', 'setSceneDestination', 'setSceneFlight'])),
  components: {
    Origins: __WEBPACK_IMPORTED_MODULE_3__Origins___default.a,
    Destinations: __WEBPACK_IMPORTED_MODULE_4__Destinations___default.a,
    Flights: __WEBPACK_IMPORTED_MODULE_5__Flights___default.a
  }
});

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(59)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-95799e60",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(56)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(68),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3fb1f70c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(60)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(72),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b520b1d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(66),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0c30dcec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(67),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2c9cf3f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.flights.length > 0) ? _c('div', [_c('div', {
    staticClass: "tools"
  }, [_c('div', {
    staticClass: "filter"
  }), _c('div', {
    staticClass: "sort"
  }, [_c('div', {
    staticClass: "space"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("\n          Sort by\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.onClickOutside),
      expression: "onClickOutside"
    }],
    staticClass: "bar"
  }, [_c('div', {
    staticClass: "selection",
    on: {
      "click": function($event) {
        _vm.sorting.menu = !_vm.sorting.menu
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.sorting.selection.display) + "\n            ")]), _vm._v(" "), (_vm.sorting.menu) ? _c('div', {
    staticClass: "menu-box"
  }, _vm._l((_vm.sorting.options), function(option) {
    return _c('div', {
      staticClass: "menu"
    }, [_c('div', {
      staticClass: "option",
      on: {
        "click": function($event) {
          _vm.sort(option)
        }
      }
    }, [_vm._v(_vm._s(option.display))])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button",
    class: {
      active: _vm.sorting.menu
    },
    on: {
      "click": function($event) {
        _vm.sorting.menu = !_vm.sorting.menu
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])])])])])]), _vm._v(" "), _c('ul', _vm._l((_vm.flights), function(flight) {
    return _c('li', [_c('flight', {
      attrs: {
        "flight": flight
      }
    })], 1)
  }))]) : _c('div', [_vm._v("Sorry, there are no flights currently available for this origin and destination.")])
},staticRenderFns: []}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.origins), function(origin) {
    return _c('li', [_c('div', {
      on: {
        "click": function($event) {
          _vm.setOrigin(origin)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": origin.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(origin.name))])])])
  })), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v("...or vote for your city to be the next origin.")]), _vm._v(" "), _c('form', [_c('input', {
    attrs: {
      "placeholder": "Your home city"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Vote")])])])
}]}

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.destinations), function(destination) {
    return _c('li', [_c('div', {
      on: {
        "click": function($event) {
          _vm.setDestination(destination)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": destination.img
      }
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(destination.name))])])])
  })), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v("...or suggest a new destination.")]), _vm._v(" "), _c('form', [_c('input', {
    attrs: {
      "placeholder": "Destination"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Suggest")])])])
}]}

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wizard"
    }
  }, [_c('div', [_c('div', {
    staticClass: "tab",
    on: {
      "click": function($event) {
        _vm.setSceneOrigin()
      }
    }
  }, [_c('div', {
    staticClass: "data left",
    class: {
      active: _vm.ifo, disabled: _vm.ifo
    }
  }, [_c('div', {
    staticClass: "step"
  }, [(_vm.origin) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v("\n            Step 1\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Origin")]), _vm._v(" "), (_vm.origin) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.origin.name))]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("Choose origin")])]), _vm._v(" "), (_vm.ifo) ? _c('span', {
    staticClass: "sha"
  }) : _vm._e(), _vm._v(" "), (_vm.ifo) ? _c('span', {
    staticClass: "bbb"
  }) : _vm._e()]), _c('div', {
    staticClass: "tab",
    on: {
      "click": function($event) {
        _vm.sceneDestination()
      }
    }
  }, [_c('div', {
    staticClass: "data",
    class: {
      active: _vm.ifd, disabled: _vm.ifd || !_vm.origin
    }
  }, [_c('div', {
    staticClass: "step"
  }, [(_vm.destination) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v("\n            Step 2\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Destination")]), _vm._v(" "), (_vm.destination) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.destination.name))]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("Choose destination")])]), _vm._v(" "), (_vm.ifd) ? _c('span', {
    staticClass: "sha"
  }) : _vm._e(), _vm._v(" "), (_vm.ifd) ? _c('span', {
    staticClass: "bbb"
  }) : _vm._e()]), _c('div', {
    staticClass: "tab",
    on: {
      "click": function($event) {
        _vm.sceneFlight()
      }
    }
  }, [_c('div', {
    staticClass: "data right",
    class: {
      active: _vm.iff, disabled: _vm.iff || !_vm.origin || !_vm.destination
    }
  }, [_c('div', {
    staticClass: "step"
  }, [_vm._v("Step 3")]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("Flight")]), _vm._v(" "), (_vm.flight) ? _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.flight.name))]) : _c('div', {
    staticClass: "text"
  }, [_vm._v("Choose flight")])]), _vm._v(" "), (_vm.iff) ? _c('span', {
    staticClass: "sha"
  }) : _vm._e(), _vm._v(" "), (_vm.iff) ? _c('span', {
    staticClass: "bbb"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [(_vm.ifo) ? _c('origins') : _vm._e(), _vm._v(" "), (_vm.ifd) ? _c('destinations') : _vm._e(), _vm._v(" "), (_vm.iff) ? _c('flights') : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "about"
    }
  }, [_c('p', [_vm._v("Want to go somewhere but don't know exactly where?")]), _vm._v(" "), _c('p', [_vm._v("Follow the steps below to figure out where!")])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wizard"
    }
  }, [_c('p', [_vm._v("Thank you for trying the demo!")]), _vm._v(" "), _c('p', [_vm._v("Here you would be able to enter all necessary information and book the ticket.")])])
}]}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flight"
  }, [_c('div', {
    staticClass: "destination"
  }, [_vm._v("\n    " + _vm._s(_vm.flight.destination.city) + "\n    "), _c('div', {
    staticClass: "toggles"
  }, [_c('div', {
    staticClass: "more-3",
    on: {
      "click": function($event) {
        _vm.flight.details = !_vm.flight.details
      }
    }
  }, [(_vm.flight.details) ? _c('i', {
    staticClass: "fa fa-toggle-on"
  }) : _vm._e(), _vm._v(" "), (!_vm.flight.details) ? _c('i', {
    staticClass: "fa fa-toggle-off"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-2"
  }, [_vm._v("Show More Flight Details")])]), _vm._v(" "), _c('div', {
    staticClass: "more-3",
    on: {
      "click": function($event) {
        _vm.flight.attractions = !_vm.flight.attractions
      }
    }
  }, [(_vm.flight.attractions) ? _c('i', {
    staticClass: "fa fa-toggle-on"
  }) : _vm._e(), _vm._v(" "), (!_vm.flight.attractions) ? _c('i', {
    staticClass: "fa fa-toggle-off"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "label-2"
  }, [_vm._v("Show Destination Attractions")])])])]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "length"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Length")]), _vm._v(" "), _c('div', {
    staticClass: "duration"
  }, [_vm._v(_vm._s(_vm.flight.trip.duration) + " days")]), _vm._v(" "), (_vm.flight.details) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("Round trip")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "leave"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Leaving")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.flight.trip.leave))]), _vm._v(" "), (_vm.flight.details) ? _c('div', {
    staticClass: "more-details"
  }, [_c('div', [_vm._v("\n          " + _vm._s(_vm.flight.origin.airport) + "\n          "), _c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v("\n          " + _vm._s(_vm.flight.destination.airport) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n        Direct flight\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.flight.airline) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "return"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Returning")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.flight.trip.return))]), _vm._v(" "), (_vm.flight.details) ? _c('div', {
    staticClass: "more-details"
  }, [_c('div', [_vm._v("\n          " + _vm._s(_vm.flight.destination.airport) + "\n          "), _c('i', {
    staticClass: "fa fa-arrow-right"
  }), _vm._v("\n          " + _vm._s(_vm.flight.origin.airport) + "\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n        Direct flight\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          " + _vm._s(_vm.flight.airline) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "data"
  }, [_vm._v("$" + _vm._s(_vm.flight.price))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.flight.attractions) ? _c('div', {
    staticClass: "attractions"
  }, [_c('ul', _vm._l((_vm.attractionsList), function(attraction) {
    return _c('li', [_c('div', {
      staticClass: "attraction"
    }, [_c('label', [_vm._v(_vm._s(attraction.name))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": attraction.img
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(attraction.description))])])])
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "act"
  }, [_c('a', {
    staticClass: "book",
    attrs: {
      "href": "/#/book"
    }
  }, [_vm._v("\n        Get this ticket\n      ")])])
}]}

/***/ })
],[18]);


// WEBPACK FOOTER //
// static/js/app.a3b4bb1e0f5505dd9ec3.js